import { render, staticRenderFns } from "./FontFamilySelector.vue?vue&type=template&id=0506fdb6&scoped=true"
import script from "./FontFamilySelector.vue?vue&type=script&lang=js"
export * from "./FontFamilySelector.vue?vue&type=script&lang=js"
import style0 from "./FontFamilySelector.vue?vue&type=style&index=0&id=0506fdb6&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506fdb6",
  null
  
)

export default component.exports